export class CardNav {
  static start() {
    const $elements = $('.card-nav');

    if ($elements) {
      $elements.each(function init_card_nav() {
        const $element = $(this);

        $element.data('card_nav', new CardNav($element));
      });
    }
  }

  constructor($element) {
    this.$element = $element;
    this.$card = $element.closest('.card');
    this.$nav_links = this.$element.find('.nav-link');

    const content_ids = [];

    this.$element.find('.nav-link').each((_, nav_link) => {
      const $nav_link = $(nav_link);
      const href = $nav_link.attr('href');

      content_ids.push(href);

      $nav_link.on('click', (event) => this.action_click(event, href));
    });

    this.$nav_targets = this.$card.find(content_ids.join(', '));

    if (window.location.hash) {
      if (!content_ids.includes(window.location.hash)) {
        window.location.hash = '';
      }
      else {
        this.set_active(window.location.hash, false);
      }
    }
    else {
      this.set_active(content_ids[0], false);
    }
  }

  action_click(event, hash) {
    event.preventDefault();
    event.stopPropagation();

    if (hash !== window.location.hash) {
      this.set_active(hash);
    }
  }

  set_active(hash, update_hash = true) {
    const $nav_link = this.$nav_links.filter(`[href='${hash}']`);

    this.$nav_links.removeClass('active');
    $nav_link.addClass('active');

    this.$nav_targets.addClass('d-none');
    $(hash).removeClass('d-none');

    if (update_hash) {
      window.location.hash = hash;
    }
  }
}
